import React from 'react';
import { ValuationsContextValues } from './types';
import { VALUATIONS_DEFAULT_CURRENCY } from '../../common/constants/valuations';

const ValuationContext = React.createContext<ValuationsContextValues>({
  approaches: null,
  backsolveAttributes: null,
  companyMeasurementDate: null,
  compGroups: null,
  disableFinancialsSelection: null,
  filesInApproach: null,
  filesInRangeSensitivity: null,
  financials: null,
  financialsCurrency: VALUATIONS_DEFAULT_CURRENCY,
  financialsPeriods: null,
  financialStatementPeriods: null,
  financialsVersions: null,
  gpcAttributes: null,
  calibrationAttributes: null,
  isChangingFinancialStatement: null,
  isEditingApproachName: null,
  isEditingCalibrationName: false,
  isEditingRangeSensitivityName: false,
  marketCurrency: VALUATIONS_DEFAULT_CURRENCY,
  marketDate: '',
  measurementDate: null,
  notesInApproach: null,
  notesInRangeSensitivity: null,
  spreadsheetNotesInRangeSensitivity: null,
  onChange: null,
  publicCompsAttrs: null,
  publicCompsByDate: null,
  resetConfiguration: null,
  selectedFinancialsVersion: null,
  setAreThereChanges: null,
  setCashTaxRate: () => {},
  setFilesInApproach: null,
  setFilesInRangeSensitivity: null,
  setNotesInApproach: null,
  setNotesInRangeSensitivity: null,
  setSpreadsheetNotesInRangeSensitivity: null,
  valuation: null,
  workbook: null,
  allocationMethodsOptions: [],
  updateApproachesScenarioMethods: () => {},
  financialStatementPeriodsPerMD: [],
  registerApproachFormat: undefined,
});

export default ValuationContext;
